<template>
    <a-modal :title="title" width="500px" :maskClosable="false" :visible.sync="show" @cancel="() => $emit('update:show', false)" :footer="null" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :style="{ marginTop: '16px' }" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="比赛信息">{{ item.name }}</a-form-model-item>
            <a-form-model-item label="倒计时间" prop="sec">
                <a-input-number v-model="field.sec" :min="10" :max="600" :formatter="value => `${value} 秒`" :parser="value => value.replace('秒', '').replace(' ', '')" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSubmit" icon="issues-close">
                    开始比赛
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            field: {
                id: '',
                sec: 10
            },
            rules: {
                sec: [{ required: true, message: '请填写倒计时秒数', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.field.id = this.item.id
    },
    methods: {
        doSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/cts/ate/race/mgr/start', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('操作成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            this.field.id = this.item.id
        }
    }
}
</script>
